import axios from 'axios'
import { useNavigate } from 'react-router';
import { BURL } from '../services/base'

const useAPI = () => {
	const navigate = useNavigate();

	axios.interceptors.response.use(res => res, (err) => {
		if (err?.response && err.response.status === 401) {
			localStorage.removeItem("token");
			navigate("/login");
		}
		return Promise.reject(err);
	});

	axios.interceptors.request.use((value) => {
		value.headers = {
			"Authorization": `Bearer ${localStorage.token}`
		};
		return value;
	})

	const POST = async (url, data) => {
		let response;
		await axios.post(`${BURL}${url}`, data).then(res => {
			response = res.data;
		}).catch(err => {
			let res = err?.response?.data;
			if (res) {
				response = res;
			} else {
				response = {
					message: "An error occured"
				}
			}
		})
		return response;
	}

	const PATCH = async (url, data) => {
		let response;
		await axios.patch(`${BURL}${url}`, data).then(res => {
			response = res.data;
		}).catch(err => {
			let res = err?.response?.data;
			if (res) {
				response = res;
			} else {
				response = {
					message: "An error occured"
				}
			}
		})
		return response;
	}

	const PUT = async (url, data) => {
		let response;
		await axios.put(`${BURL}${url}`, data).then(res => {
			response = res.data;
		}).catch(err => {
			let res = err?.response?.data;
			if (res) {
				response = res;
			} else {
				response = {
					message: "An error occured"
				}
			}
		})
		return response;
	}

	const GET = async (url) => {
		let response;
		await axios.get(`${BURL}${url}`).then(res => {
			response = res.data;
		}).catch(err => {
			let res = err?.response?.data;
			if (res) {
				response = res;
			} else {
				response = {
					message: "An error occured"
				}
			}
		})
		return response;
	}

	const DELETE = async (url, data, token) => {
		let response;
		await axios.delete(`${BURL}${url}`, {
			data: data
		})
			.then(res => {
				response = res.data;
			})
			.catch(err => {
				response = err?.response?.data || { message: "An error occurred" };
			});

		return response;
	}

	const DELETEREQ = async (url, data) => {
		let response;
		await axios.delete(`${BURL}${url}`, {
			data: data
		})
			.then(res => {
				response = res.data;
			})
			.catch(err => {
				response = err?.response?.data || { message: "An error occurred" };
			});

		return response;
	}


	const deleteRequest = async (url, body, token) => {
		try {
			const response = await fetch(url, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify(body), // Attach body here
			});

			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}

			const result = await response.json();
			return result;
		} catch (error) {
			//   throw error;
			return error;
		}
	};

	return { POST, PATCH, PUT, GET, DELETE, DELETEREQ, deleteRequest }
}


export default useAPI